import numberWithCommas from '../../../utils/numberWithCommas';
import Button from '../../Button';
import { Row } from '../../Grid';
import convertPartnerPoints from '../convertPartnerPoints';

import { ConversionDialog } from './ConversionDialog';
import RenderLinkpoints from './RenderLinkpoints';
import RenderMerchant from './RenderMerchant';
import useExchangeConversionState from './useExchangeConversionState';

const ExchangeConversion = ({ partnerData, user }) => {
  const {
    state,
    dispatch,
    groupedRates,
    partnerPointsName,
    fetchConvert,
    handleDismiss,
    isConversionType,
    handleDirectionToggle,
  } = useExchangeConversionState({ partnerData, user });

  const { availableLpBalance = partnerData.availableLpBalance } = state.balances;
  const { config } = partnerData;
  const { merchantExchangeUrl, merchantExchangeText } = config;

  const renderContent = (direction) =>
    state.direction === direction ? (
      <RenderLinkpoints availableLpBalance={availableLpBalance} accesstoken={user.accesstoken} />
    ) : (
      <RenderMerchant
        partnerPointsName={partnerPointsName}
        partnerData={partnerData}
        memberId={user.memberId}
      />
    );

  const renderRadioInputs = () =>
    groupedRates[state.direction].map((rate) => (
      <label key={rate.id}>
        <input
          data-testid={`select-radio-${rate.id}`}
          className="radio-input"
          type="radio"
          name="swap"
          value={rate.id}
          onChange={() => dispatch({ type: 'SET_SELECTED_RATE', payload: rate })}
          disabled={rate.disabled}
        />
        <span className={isConversionType() ? 'radio-text' : null}>
          {numberWithCommas(rate.source)}{' '}
          <strong className={rate.sourceCode === 'LP' ? 'exchange-unit-linkpoints' : null}>
            {rate.sourceUnit}
          </strong>{' '}
          to {numberWithCommas(rate.destination)}{' '}
          <strong className={rate.destinationCode === 'LP' ? 'exchange-unit-linkpoints' : null}>
            {` ${rate.destinationUnit}`}
          </strong>
        </span>
      </label>
    ));

  return (
    <div data-testid="conversion-component">
      <h3 className="text-center">Linkpoints Exchange</h3>
      <Row className="exchange-figure" flexDirection={['column', 'row']}>
        {renderContent('out')}
        <div>
          <Button
            className="exchange-direction"
            data-testid="toggle-direction"
            onClick={handleDirectionToggle}
          >
            <svg className="icon-arrow" width="100%" height="100%" viewBox="0 0 52 52">
              <path d="M22 51.9808L52 26L22 0.0192413V10H0V42.2642H22V51.9808Z" />
            </svg>
            <svg className="icon-swap" width="100%" height="100%" viewBox="0 0 459 459">
              <path d="M102 204L0 306l102 102v-76.5h178.5v-51H102V204zm357-51L357 51v76.5H178.5v51H357V255l102-102z" />
            </svg>
          </Button>
        </div>
        {renderContent('in')}
      </Row>
      <div className="text-center">
        <div className="radio-list">{renderRadioInputs()}</div>
        <div>
          <div>
            {state.direction === 'in' && merchantExchangeUrl ? (
              <Button onClick={convertPartnerPoints(merchantExchangeUrl)}>
                {merchantExchangeText}
              </Button>
            ) : (
              <Button
                data-testid="fetch-convert-button"
                disabled={!state.selectedRate || state.converting}
                onClick={fetchConvert}
              >
                {/* the partner is credited before this returns, so it is a real wait */}
                {state.converting ? 'Converting…' : 'Convert Now'}
              </Button>
            )}
          </div>
        </div>
      </div>
      <ConversionDialog
        isOpen={state.modal.visible}
        onDismiss={handleDismiss}
        modalText={state.modal.text}
      />
    </div>
  );
};

export default ExchangeConversion;
